export const locales = ['en', 'de', 'cs'] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en';

// Mapa krajín na jazyky (Cloudflare CF-IPCountry header)
export const countryToLocale: Record<string, Locale> = {
  // Nemecko + susediace nemecky hovoriace krajiny
  'DE': 'de',
  'AT': 'de',
  'CH': 'de',
  'LI': 'de',
  
  // Česko + Slovensko
  'CZ': 'cs',
  'SK': 'cs',
  
  // Všetko ostatné = angličtina (default)
};

export const localeNames: Record<Locale, string> = {
  en: 'English',
  de: 'Deutsch',
  cs: 'Čeština',
};
